import { NavLink } from "react-router-dom";
import {
  ClipboardList,
  FileText,
  ShoppingBag,
  Package,
  User,
  Award,
  Settings,
  Menu,
  MessageCircle,
  Sliders,
} from "lucide-react";
import './styles.css'; // Custom scrollbar styles

function Sidebar({ isCollapsed, onToggle }) {
  const menuGroups = [
    {
      title: "CRM",
      items: [
        { id: "leads", name: "Leads", route: "/leads", icon: <ClipboardList /> },
        { id: "opportunities", name: "Opportunities", route: "/opportunities", icon: <FileText /> },
        { id: "sales", name: "Sales", route: "/sales", icon: <ShoppingBag /> },
        { id: "inventory", name: "Inventory", route: "/inventory", icon: <ClipboardList /> },
        { id: "customers", name: "Customers", route: "/customers", icon: <User /> },
        { id: "orders", name: "Orders", route: "/orders", icon: <ShoppingBag /> },
        { id: "rewards", name: "Rewards", route: "/rewards", icon: <Award /> },
      ],
    },
    {
      title: "Operations",
      items: [
        { id: "workorders", name: "Work Orders", route: "/workorders", icon: <Package /> },
        { id: "engagehub", name: "Engage Hub", route: "/engagehub", icon: <MessageCircle /> },
        { id: "managementframework", name: "Management Framework", route: "/management", icon: <Sliders /> },
        { id: "adminpage", name: "Admin Panel", route: "/adminpage", icon: <Settings /> },
      ],
    },
  ];

  return (
    <aside
      className={`${
        isCollapsed ? "w-18" : "w-64"
      } bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 h-[calc(100vh-4rem)] transition-all duration-300 flex flex-col justify-between shadow-lg fixed top-16`}
    >
      {/* Brand Section */}
      <div className="px-4 py-4 flex items-center justify-between">
        {!isCollapsed && (
          <h2 className="text-2xl font-bold text-blue-500">
            iDecision<span className="text-white">CRM</span>
          </h2>
        )}
        <button
          className="text-gray-400 hover:text-white focus:outline-none"
          onClick={onToggle}
        >
          <Menu className={`w-6 h-6 transform transition-transform ${isCollapsed ? "rotate-180" : ""}`} />
        </button>
      </div>

      {/* Navigation Section */}
      <nav className="flex-1 px-2 space-y-4 overflow-y-auto custom-scrollbar">
        {menuGroups.map((group) => (
          <div key={group.title}>
            {!isCollapsed && (
              <h3 className="uppercase text-gray-400 text-xs tracking-wider font-semibold py-2 px-4">
                {group.title}
              </h3>
            )}
            <ul className="space-y-1">
              {group.items.map((item) => (
                <li key={item.id}>
                  <NavLink
                    to={item.route}
                    className={({ isActive }) =>
                      `flex items-center gap-3 p-3 rounded-lg text-sm font-medium transition-all ${
                        isActive
                          ? "bg-blue-600 text-white border-l-4 border-blue-500 shadow-md"
                          : "text-gray-400 hover:bg-gray-800 hover:text-white"
                      }`
                    }
                  >
                    <span className="w-6 h-6">{item.icon}</span>
                    {!isCollapsed && <span>{item.name}</span>}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>

      {/* Footer Section */}
      <div className="px-4 py-3 text-sm text-gray-500 mt-auto">
        {!isCollapsed && <span>© 2025 iDecisionCRM</span>}
      </div>
    </aside>
  );
}

export default Sidebar;